import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'util';
import { IReaderAdmin } from '../../../models/IReader';
import UserAdminServiceInstance from '../../../services/UserAdminService';
import OntimeAutocomplete from '../../common/OntimeAutocomplete';

interface IReaderErrors {
    readerId?: string;
    manufacturer?: string;
    model?: string;
    description?: string;
    assignedTo?: string;
}
interface IEditReaderDialogProps {
    reader: IReaderAdmin;
    onCompleteEdit: (circuit: IReaderAdmin) => void;
    onCancelEdit: () => void;
}

function EditReaderDialog(props: IEditReaderDialogProps) {
    const { t } = useTranslation("common");
    const [currentReader, setCurrentReader] = useState<IReaderAdmin>(props.reader);
    const [errors, setErrors] = React.useState<IReaderErrors>();
    
    const handleClose = () => {
        props.onCancelEdit();
    }

    const handleCompleteEdit = () => {
        props.onCompleteEdit(currentReader);
        handleClose();
    }

    const checkReader = (readerToValidate: IReaderAdmin) => {
        const error: IReaderErrors = {};
        let anyError = false;
        if (readerToValidate) {
            if (readerToValidate.readerId.length === 0) {
                error.readerId = format(t("commonErrors.requiredField"), t("circuitSetup.name"));
                anyError = true;
            }

        }
        if (anyError === true) {
            setErrors(error);
        } else {
            setErrors(undefined);
        }
    }


    return (
        <Dialog open={true} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{t("readersSetup.dialogTitle")}</DialogTitle>
            <DialogContent>

                <TextField
                    autoFocus
                    error={Boolean(errors?.readerId)}
                    helperText={errors?.readerId}
                    margin="dense"
                    id="readerId"
                    label={t("readersSetup.readerId")}
                    type="text"
                    fullWidth
                    value={currentReader.readerId}
                    onChange={e => {
                        const newReader: IReaderAdmin = { ...currentReader, readerId: e.target.value };
                        setCurrentReader(newReader);
                        checkReader(newReader);
                    }}
                />
                <TextField
                    error={Boolean(errors?.manufacturer)}
                    helperText={errors?.manufacturer}
                    margin="dense"
                    id="manufacturer"
                    label={t("readersSetup.manufacturer")}
                    type="string"
                    value={currentReader.manufacturer}
                    onChange={e => {
                        const newReader: IReaderAdmin = { ...currentReader, manufacturer: e.target.value };
                        setCurrentReader(newReader);
                        checkReader(newReader);
                    }}
                />
                <TextField
                    error={Boolean(errors?.model)}
                    helperText={errors?.model}
                    margin="dense"
                    id="model"
                    label={t("readersSetup.model")}
                    type="string"
                    value={currentReader.model}
                    onChange={e => {
                        const newReader: IReaderAdmin = { ...currentReader, model: e.target.value };
                        setCurrentReader(newReader);
                        checkReader(newReader);
                    }}
                />
                <TextField
                    error={Boolean(errors?.description)}
                    helperText={errors?.description}
                    margin="dense"
                    id="description"
                    label={t("readersSetup.description")}
                    type="string"
                    value={currentReader.description}
                    onChange={e => {
                        const newReader: IReaderAdmin = { ...currentReader, description: e.target.value };
                        setCurrentReader(newReader);
                        checkReader(newReader);
                    }}
                />
                <OntimeAutocomplete
                    id="assignedTo"
                    label={t("readersSetup.assignedTo")}
                    itemIdProperty="userId"
                    itemLabelProperty="name"
                    valueId={currentReader.assignedToObjectId}
                    search={UserAdminServiceInstance.searchOrganizers}
                    onChange={(e, value) => {
                        if (value?.userId) {
                            const newReader: IReaderAdmin = { ...currentReader, assignedToObjectId: value.userId };
                            setCurrentReader(newReader);
                            checkReader(newReader);
                        }
                    }} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCompleteEdit} color="primary" disabled={errors !== undefined}>
                    {t("commonActions.ok")}
                </Button>
                <Button onClick={handleClose} color="primary">
                    {t("commonActions.cancel")}
                </Button>
            </DialogActions>
        </Dialog >
    );
}

export default EditReaderDialog;